var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',[_c('div',{staticClass:"container-fluid texto row"},[_c('div',{staticClass:"col d-flex px-5 py-3"},[_c('div',[_vm._v("Copyright - AbaKan Sistemas - "),_c('small',[_vm._v("v"+_vm._s(_vm.version))])]),_c('div',{staticClass:"ml-auto pr-4"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }